var _effectorFileName = "/builds/gmini/front-common/src/classifier-service/Node/Reference.ts";
// eslint-disable-next-line import/no-cycle
// eslint-disable-next-line import/no-cycle
export var isReferenceNode = function isReferenceNode(node) {
  return isBimModelReferenceNode(node) || isBimCategoryReferenceNode(node) || isBimFamilyReferenceNode(node) || isBimStandardSizeReferenceNode(node) || isBimElementReferenceNode(node);
};
export var isReferenceNodeRef = function isReferenceNodeRef(r) {
  return (// eslint-disable-next-line @typescript-eslint/no-explicit-any
    isReferenceNode(r)
  );
};
export var isBimModelReferenceNode = function isBimModelReferenceNode(node) {
  return node.type === 'BimModelReferenceNode';
};
export var isBimCategoryReferenceNode = function isBimCategoryReferenceNode(node) {
  return node.type === 'BimCategoryReferenceNode';
};
export var isBimFamilyReferenceNode = function isBimFamilyReferenceNode(node) {
  return node.type === 'BimFamilyReferenceNode';
};
export var isBimStandardSizeReferenceNode = function isBimStandardSizeReferenceNode(node) {
  return node.type === 'BimStandardSizeReferenceNode';
};
export var isBimElementReferenceNode = function isBimElementReferenceNode(node) {
  return node.type === 'BimElementReferenceNode';
};
export var isDynamicBimElementReferenceNode = function isDynamicBimElementReferenceNode(node) {
  return node.type === 'DynamicBimElementReferenceNode';
};